function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { styled } from 'styled-components';
import { Button } from '../../Button';
const DeleteButton = styled(Button).withConfig({
  componentId: "aui__sc-vv79tk-0"
})(["z-index:1;position:absolute;top:0.5rem;right:0.5rem;"]);
export const ImagePreviewTrashButton = props => /*#__PURE__*/React.createElement(DeleteButton, _extends({
  iconSrc: "bin",
  size: "small",
  "data-testid": "trash-can-delete-button",
  "aria-label": "Delete trash can icon"
}, props));